/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DoctorLanguage from './doctor-language';
import DoctorLanguageDetail from './doctor-language-detail';
import DoctorLanguageUpdate from './doctor-language-update';
import DoctorLanguageDeleteDialog from './doctor-language-delete-dialog';

const DoctorLanguageRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DoctorLanguage />} />
    <Route path="new" element={<DoctorLanguageUpdate />} />
    <Route path=":id">
      <Route index element={<DoctorLanguageDetail />} />
      <Route path="edit" element={<DoctorLanguageUpdate />} />
      <Route path="delete" element={<DoctorLanguageDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DoctorLanguageRoutes;
